module.exports = __webpack_public_path__ + "static/media/model-login-header.0235c226.jpg";